import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetchAndResolve } from 'motion-master-client';
import { ToastrService } from 'ngx-toastr';
import { switchMap, tap } from 'rxjs/operators';

import { loadErrorReportsFailure, loadErrorReportsRequest, loadErrorReportsSuccess } from './error-report.actions';
import { ErrorReport } from './error-report.model';

@Injectable()
export class ErrorReportEffects {
  private actions$ = inject(Actions);
  private toastr = inject(ToastrService);

  handleLoadErrorReportsRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadErrorReportsRequest),
      switchMap(async () => {
        try {
          const errorReports: ErrorReport[] = (await fetchAndResolve('/error-reports-v2.json', 'json', true)) ?? [];
          return loadErrorReportsSuccess({ errorReports });
        } catch (error) {
          return loadErrorReportsFailure({ error });
        }
      }),
    ),
  );

  handleLoadErrorReportsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadErrorReportsFailure),
        tap((action) => {
          this.toastr.error('Failed to load error reports. Error: ' + action.error?.message, 'Load Error Reports', {
            disableTimeOut: true,
          });
        }),
      ),
    { dispatch: false },
  );
}
